module.exports = __webpack_public_path__ + "img/plazasminusvalidos.9c5c1674.png";